<template>
  <div class="header-container">
    <lay @click.native="disappear" v-show="layShow" v-bind:msglay="msglay"></lay>
    <!-- 登录弹框 -->
    <login class="content_login" v-show="loginShow" v-bind:msglogin="msglogin" v-on:showChanged="showChange($event)">
    </login>
    <!-- 导航栏 -->
    <div class="header">
      <!-- 左边logo -->
      <a href="../index.html" :class="['logo',{'logo-red':color!='#fff'}]" >
      </a>
      <!-- 右边栏目 -->
      <div>
        <ul class="header-tab" :style="{color:color}">
          <!-- 百花计划 -->
          <li class=" header-tab-li" v-if="pageName != 'baihua'">
            <div class="bai-hua">{{ $t('header.baihuaAward') }}</div>
            <a href="../baihua.html" :style="{cursor: 'pointer',color:color}">{{ $t('header.baihuaTitle') }}</a>
          </li>
          <!-- 首页 -->
          <li class=" header-tab-li" v-show="islogin">
            <a :href="'/loginhome.html?id=' + user_id " style="cursor: pointer;" :style="{cursor: 'pointer',color:color}">{{ $t('header.myHome') }}</a>
          </li>
          <!-- 热门直播 -->
          <li class=" header-tab-li">
            <a href="../live-all.html" :style="{cursor: 'pointer',color:color}">{{$t('header.live')}}</a>
          </li>
          <!-- 话题 -->
          <li class=" header-tab-li">
            <a href="../topic-all.html" :style="{cursor: 'pointer',color:color}">{{$t('header.topic')}}</a>
          </li>
          <!-- 充值 -->
          <li @click="pay" class='header-tab-li' >
            <a :style="{color:color}">{{$t('header.nav2')}}</a>
          </li>
          <!-- 主播中心 -->
          <li >
            <a :style="{cursor: 'default',color:color}">{{$t('header.nav3')}}</a>
            <div class="pc-liver" style="cursor: default;">{{$t('header.nav3_5')}}</div>
            <el-cascader id="cascader" :options="options" :props="{ expandTrigger: 'hover' }" @change="handleChange">
            </el-cascader>
          </li>
          <li>
            <el-dropdown trigger="click" @command="handleCommand" :style="{color:color}">
              <span class="el-dropdown-link">
                {{currUseLanguage}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="zh-Hans-TW">简体中文</el-dropdown-item>
                <el-dropdown-item command="zh-Hant-TW">繁體中文</el-dropdown-item>
                <el-dropdown-item command="en">English</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <!-- 关于我们 -->
          <li  >
            <el-dropdown trigger="click"  :style="{color:color}">
              <span class="el-dropdown-link">
                {{$t('header.nav5')}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item ><a href="/les-app.html" >{{ $t('home.appProfile') }}</a> </el-dropdown-item>
                <el-dropdown-item ><a href="/about-us.html" >{{ $t('header.nav5') }}</a> </el-dropdown-item>
                <el-dropdown-item ><a href="http://rela.cn" >{{ $t('header.jihua') }}</a> </el-dropdown-item>
                <el-dropdown-item ><a href="https://www.sobot.com/chat/pc/index.html?sysNum=4717b63070614a289c61072945a75770" >{{ $t('header.ContactUs') }}</a> </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li class="header-tab-li" v-show="!islogin" @click="appear" >
            <a :style="{color:color}" href="#">{{$t('header.nav6')}}</a>
          </li>
          <li class="user" :style="{color:color}" style="border-radius: 50%;padding-right: 30px;"
            v-show="islogin">
            <img style="height: 100%;border-radius: 50%;" :src="avatar" />
            <div class="user_info">
              <div class="user_info_lay"></div>
              <div class="user_info_little">
                <div class="user_info_little_avatar">
                  <img style="width: 100%;height: 100%;border-radius: 50%;" :src="avatar" />
                </div>
                <div class="user_info_little_avatar_info">
                  <p>{{nickname}}</p>
                  <p>LesPark ID: {{lgid}}</p>
                </div>
              </div>
              <div @click="quit" class="user_info_recharge user_info_quit">
                <a>{{$t('header.me2')}}</a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import cookie from 'Common/cookie';
  import Vue from 'vue'
  import util from 'Common/util';
  import login from 'Views/components/login'
  import lay from 'Views/components/lay'
  import ajax from 'Common/ajax';
  import constans from 'Constans';
  import bus from 'Common/events-bus';
  import VueMeta from 'vue-meta'
  import {
    Loading, Icon, Button, MessageBox, Row, Col, Input, Select, Option, Cascader, Dropdown,
    DropdownMenu,
    DropdownItem,
  } from "element-ui";
  Vue.prototype.$confirm = MessageBox.confirm;
  import 'Views/css/header.css'

  Vue.use(VueMeta)
  Vue.use(Cascader)
  Vue.use(Dropdown)
  Vue.use(DropdownMenu);
  Vue.use(DropdownItem);
  const userUrl = constans.AllUrl.url.dev;
  const goLinkUrl = constans.UrlLink.goLink.header;
  const goLinkeKey = constans.UrlLink.getUrlKey();

  export default {
    name: 'myHeader',
    data() {
      return {
        useLanguage: ['简体中文', '繁體中文', 'English'],
        currUseLanguage: '简体中文',//当前用户语言
        simplifyLanguage: ['简体中文', '繁體中文', 'English'],
        traditionalLanguage: ['简体中文', '繁體中文', 'English'],
        englishLanguage: ['简体中文', '繁體中文', 'English'],
        loginShow: false, //登录框是否显示
        layShow: false, //蒙层是否显示
        msglay: false, //从子组件<lay>收到的值
        msglogin: false, //从子组件<login>收到的值
        islogin: false, //判断是否登录
        user_id: cookie.getCookie("lespark_user_id"),
        token: cookie.getCookie("lespark_token") || "",
        avatar: '',
        lgid: cookie.getCookie('lgid') != '' ? cookie.getCookie('lgid') : '',
        nickname: '',
        chaneMode: false,
        author_live: null,
        language: '',
        htmlLang: '',
        options: []
      }
    },
    components: {
      login: login,
      lay: lay,
    },
    props: {
      color: {
        type: String,
        default: '#fff'
      },
      pageName:{
        type: String,
        default: ''
      }
    },
    metaInfo() {
      return {
        htmlAttrs: {
          lang: this.htmlLang,
          // amp: true
        },
      }
    },
    created() {
      var that = this
      let _arg = util.getQueryStringArgs();
      if (_arg.lang == 'zh-Hans-TW') {
        that.language = '简体中文'
      } else if (_arg.lang == 'zh-Hant-TW') {
        that.language = '繁體中文'
      } else if (_arg.lang == 'en') {
        that.language = 'English'
      } else {
        that.language = cookie.getCookie('language') || util.getLang()
      }
      if (that.language == '简体中文' || that.language == 'cn') {
        that.$i18n.locale = 'zh'
        that.chaneMode = false
        that.currUseLanguage = '简体中文'
        bus.$emit('CL', 'CL_zh');
        cookie.setCookie('language', '简体中文')
        that.htmlLang = 'zh-Hans-TW'

      }
      else if (that.language == '繁體中文'  || that.language == 'tw') {
        that.$i18n.locale = 'zh-f'
        that.chaneMode = false
        that.currUseLanguage = '繁體中文'
        bus.$emit('CL', 'CL_zh_f');
        cookie.setCookie('language', '繁體中文')
        that.htmlLang = 'zh-Hant-TW'
      }
      else {
        that.$i18n.locale = 'en'
        that.chaneMode = true
        that.currUseLanguage = 'English'
        bus.$emit('CL', 'CL_en');
        cookie.setCookie('language', 'English')
        that.htmlLang = 'en'
      }
      var urlError = util.getQueryString('error') != '' ? util.getQueryString('error') : ''
      var user_id = cookie.getCookie("lespark_user_id")
      var token = cookie.getCookie("lespark_token") || ''
      var source = util.getQueryString('source') != '' ? util.getQueryString('source') : ''

      cookie.setCookie('source', source)
      if (urlError != '') {
        alert('urlError')
      }
      ajax.getAllData({
        url: userUrl + '/pc_index',
        headers: {
          bundle_id: 'pc',
          'bundle-id': 'pc',
          lang: 'zh-hans',
          user_id: user_id,
          token: token,
        },
        params: {
          source: source
        },
      }).then(allData => {
        const ref = allData.data
        that.isbot = allData.headers.from_spider || ''
        that.showMask()
        if (ref.msg == 'ok' && ref.error == 0) {
          if (ref.hasOwnProperty('data') && ref.data.hasOwnProperty('lgid')) {
            that.avatar = ref.data.avatar
            that.lgid = ref.data.lgid
            that.nickname = ref.data.nickname
            that.user_id = user_id
            that.token = token
            cookie.setCookie('avatar', ref.data.avatar)
            cookie.setCookie('lgid', ref.data.lgid)
            cookie.setCookie('nickname', ref.data.nickname)
            cookie.setCookie('lespark_token', token)
            cookie.setCookie('lespark_user_id', user_id)
            that.islogin = true
            bus.$emit('userLogin', 'userLogin')
          } else {
            cookie.setCookie('lespark_token', '')
            cookie.setCookie('lespark_user_id', '')
            cookie.setCookie('lgid', '')
            cookie.setCookie('avatar', '')
            cookie.setCookie('nickname', '')
            that.islogin = false
          }

          var qr_img_url = ref.data.qr_img_url
          var ios_url = ref.data.ios_url
          var android_url = ref.data.android_url
          var google_url = ref.data.google_url
          var url = {}

          url = {
            'android_url': android_url,
            'google_url': google_url,
            'ios_url': ios_url,
            'qr_img_url': qr_img_url
          }

          if (ref.data.android_url != '' || ref.data.android_url != undefined) {
            bus.$emit('url', url)
            bus.$emit('regUrl', qr_img_url)
          }
        }

      }).catch(ref => {
        cookie.setCookie('lespark_token', '')
        cookie.setCookie('lespark_user_id', '')
        cookie.setCookie('lgid', '')
        cookie.setCookie('avatar', '')
        cookie.setCookie('nickname', '')
        that.islogin = false
      })
    },
    mounted() {
      const that = this
      let _ = this;
      _.$bus.on('noLoginInfo', function (res) {
        _.appear();
      })
      _.$bus.on('quit', function (res) {
        _.quit();
      })
      let lespark_user_id = '{{ user_id }}'||null
      let lespark_token = '{{ token }}'||null
      if(lespark_user_id && String(lespark_user_id).length==24){
      cookie.setCookie('lespark_user_id', lespark_user_id);
    }
    if(lespark_token && String(lespark_token).length==32){
      cookie.setCookie('lespark_token', lespark_token);
    }
      that.options  = that.$t('headerOptions')
    },
    methods: {
      closeWebPage() {
        if (navigator.userAgent.indexOf("Firefox") > 0) {
          window.location.href = 'about:blank ';
        } else {
          window.opener = null;
          window.open("about:blank", "_top").close()
        }
      },
      handleChange(value) {
        const flag = value[1]
        if (flag == 'pc') {//开始pc直播
          window.location.href = '/live_start.html'
        }else{
          window.location.href = goLinkUrl[flag][goLinkeKey]
        }
      },
      //判断条件，询问用户是否男性
      showMask() {
        const that = this
        let _arg = util.getQueryStringArgs();
        if (_arg.login == 'true') {
          //登陆弹窗
          that.appear();
        } else {
          const lespark_female = localStorage.getItem('lespark_female') || ''
          if (!that.isbot && !lespark_female && !util.liveStartisLogin() && !util.isPhantomjs()) {
            this.$confirm('LesPark是一个成年小姐姐专属的社区，暂不对未成年人和男性用户开放，一经发现会进行封号处理哦！', '提示', {
              confirmButtonText: '我是成年小姐姐',
              cancelButtonText: '关闭',
              showClose: false,
              closeOnClickModal: false,
              type: 'warning'
            }).then((res) => {
              if (res == 'confirm') {
                localStorage.setItem('lespark_female', true)
              } else {
                that.closeWebPage()
              }
            }).catch((ref) => {
              that.closeWebPage()
            });
          }
        }
      },
      handleCommand(command) {
        this.changeLanguage(command)
        window.location.href = '?lang=' + command
      },
      // 切换语言
      changeLanguage(value) {
        const that = this
        var url = window.document.URL
        var urlNumber = url.indexOf('live.html')
        if (value == 'zh-Hans-TW') {
          that.language = '简体中文'
          if (urlNumber != -1) {
            that.author_live = cookie.getCookie('author_live')
            window.document.title = '“' + that.author_live + "”的直播间 - LesPark 直播";
          }
          cookie.setCookie('language', '简体中文')
          that.$i18n.locale = 'zh'
          that.chaneMode = false
          bus.$emit('CL', 'CL_zh');
          that.currUseLanguage = '简体中文'
        } else if (value == 'zh-Hant-TW') {
          that.language = '繁體中文'
          if (urlNumber != -1) {
            that.author_live = cookie.getCookie('author_live')
            window.document.title = '“' + that.author_live + "”的直播间 - LesPark 直播";
          }
          cookie.setCookie('language', '繁體中文')
          that.$i18n.locale = 'zh-f'
          that.chaneMode = false
          bus.$emit('CL', 'CL_zh_f');
          that.currUseLanguage = '繁體中文'
        } else {
          that.language = 'English'
          cookie.setCookie('language', 'English')
          if (urlNumber != -1) {
            that.author_live = cookie.getCookie('author_live')
            window.document.title = '“' + that.author_live + "”的直播间 - LesPark Live";
          }
          that.$i18n.locale = 'en'
          that.chaneMode = true
          bus.$emit('CL', 'CL_en');
          that.currUseLanguage = 'English'
        }
      },

      // 登陆组件出现
      appear(e) {
        var that = this
        that.loginShow = true
        that.layShow = true
      },
      // 登陆组件消失
      disappear() {
        var that = this
        that.loginShow = false
        that.layShow = false
        window.document.body.className = ''
      },
      // 登陆组件出现
      showChange(msg) {
        var that = this
        that.msglogin = msg;
        if (msg == false) {
          that.loginShow = msg
          that.layShow = msg
          window.document.body.className = ''
        }
        if (msg == 'islogin') {
          bus.$emit('attentionShow', 'headerto');
          bus.$emit('userLiveShow', 'headerto');
        }
      },
      // 退出登录
      quit() {
        var that = this

        ajax.Post({
          url: userUrl + '/setting/logout',
          headers: {
            user_id: cookie.getCookie("lespark_user_id"),
            token: cookie.getCookie("lespark_token") || "",
            'bundle_id': "pc"
          },
        }).then(ref => {
          if (ref.error == 0) {
            cookie.setCookie('lespark_token', '')
            cookie.setCookie('lespark_user_id', '')
            cookie.setCookie('lgid', '')
            cookie.setCookie('avatar', '')
            cookie.setCookie('nickname', '')
            cookie.setCookie('user_id', '')
            cookie.setCookie('token', '')
            that.islogin = false

            // 关注列表显示
            bus.$emit('attentionShow', 'noheaderto')
            bus.$emit('userLiveShow', 'noheaderto');

            //退出直播间
            bus.$emit('quit', 'quit');

            //退出登录
            bus.$emit('userLogOut', false);

            //跳回首页
            location.href = '../index.html';

          } else {
          }

        }).catch(ref => {
        })
      },
      // 充值
      pay() {
        window.open('//'+goLinkUrl['pay'][goLinkeKey]+'?language=' + encodeURIComponent(encodeURIComponent(this.language)))
      },
      aboutUS() {
        window.open('//www.lespark.cn/about_us_cn.html?language=' + encodeURIComponent(encodeURIComponent(this.language)))
      },

    },
    watch: {
      msglogin(newVal, oldVal) {
        if (newVal == 'islogin') {
          this.islogin = true
          this.loginShow = false
          this.layShow = false
          window.document.body.className = ''
        }
        this.msglogin = false
        this.user_id = cookie.getCookie("lespark_user_id")
        this.token = cookie.getCookie("lespark_token") || ""
        this.lgid = cookie.getCookie('lgid') != '' ? cookie.getCookie('lgid') : ''
        var nickname = cookie.getCookie('nickname') != '' ? cookie.getCookie('nickname') : ''
        var avatar = cookie.getCookie('avatar') != '' ? cookie.getCookie('avatar') : ''
        if (nickname.indexOf("\"") == 0) {
          this.nickname = nickname.slice(1, nickname.length - 1)
        } else {
          this.nickname = nickname
        }
        if (avatar.indexOf("\"") == 0) {
          this.avatar = avatar.slice(1, avatar.length - 1)
        } else {
          this.avatar = avatar
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/components/header.vue